import { render, staticRenderFns } from "./course-modal.vue?vue&type=template&id=eefd46bc&scoped=true&"
import script from "./course-modal.vue?vue&type=script&lang=js&"
export * from "./course-modal.vue?vue&type=script&lang=js&"
import style0 from "./course-modal.vue?vue&type=style&index=0&id=eefd46bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefd46bc",
  null
  
)

export default component.exports